import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
import PropTypes from "prop-types";

const DashboardChartsDateContext = createContext(null);

export function DashboardChartsDateProvider({ children }) {
  const [customRange, setCustomRangeState] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogAnchorEl, setDialogAnchorEl] = useState(null);

  const setCustomRange = useCallback((range) => {
    setCustomRangeState(range);
  }, []);

  const clearCustomRange = useCallback(() => {
    setCustomRangeState(null);
  }, []);

  const value = useMemo(
    () => ({
      customRange,
      setCustomRange,
      clearCustomRange,
      dialogOpen,
      dialogAnchorEl,
      openDialog: (anchorEl) => {
        setDialogAnchorEl(anchorEl ?? null);
        setDialogOpen(true);
      },
      closeDialog: () => {
        setDialogOpen(false);
        setDialogAnchorEl(null);
      },
    }),
    [customRange, dialogOpen, dialogAnchorEl, setCustomRange, clearCustomRange]
  );

  return <DashboardChartsDateContext.Provider value={value}>{children}</DashboardChartsDateContext.Provider>;
}

DashboardChartsDateProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export function useDashboardChartsDate() {
  const ctx = useContext(DashboardChartsDateContext);
  if (ctx == null) {
    throw new Error("useDashboardChartsDate must be used within DashboardChartsDateProvider");
  }
  return ctx;
}
